import AddOnsItem from './AddOnsItem';
import PackageItem from './PackageItem';
import PatientInfoCard from './PatientInfoCard';
import { ClipboardIcon } from '@/assets/svg';
import {
  Container,
  Paper,
  Box,
  Grid,
  Typography,
  Divider,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { isEmpty } from 'lodash';
import React from 'react';

const useStyles = makeStyles({
  container: {
    display: 'flex',
  },

  rightContainer: {
    width: '60%',
    overflowY: 'scroll',
    overflowX: 'hidden',
    padding: '36px 8px',
    flex: '1',
    borderLeft: '1px solid #F1F1F1',
    height: 'calc(100vh - 222px)',
  },

  leftContainer: {
    width: '40%',
    overflow: 'scroll',
    padding: '20px',
    display: 'flex',
    height: 'calc(100vh - 222px)',
    alignItems: 'flex-end',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 16,
    fontSize: 20,
    gap: 8,
    color: '#333333',
  },
  disabledSwitch: {
    pointerEvents: 'none',
    cursor: 'not-allowed',
  },
});

const ProfileScreen = ({ dataInfo }) => {
  const classes = useStyles();
  const newListProfiles = [
    {
      category: 'Profiles',
      items: dataInfo?.lstProfiles || [],
    },
  ].concat(dataInfo?.lstTests || []);

  return (
    <Container
      maxWidth={false}
      component={Paper}
      square
      variant="outlined"
      className={classes.container}
    >
      <Box
        flexDirection="column"
        className={classes.leftContainer}
        gridGap={16}
      >
        <PatientInfoCard dataInfo={dataInfo} />
      </Box>
      <Box className={classes.rightContainer}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography className={classes.title}>
              <ClipboardIcon style={{ color: '#666666' }} />
              Selected packages
            </Typography>
          </Grid>
          {!isEmpty(dataInfo?.lstPackages) && (
            <Grid item xs={12}>
              <PackageItem
                dataInfor={dataInfo}
                isRegisterPatient
                listData={dataInfo?.lstPackages}
                ignoredTests={dataInfo?.ignoredTests}
                ignoredProfiles={dataInfo?.ignoredProfiles}
                restrictedTestIds={[]}
              />
            </Grid>
          )}
          {!isEmpty(dataInfo?.lstPackages) &&
            (!isEmpty(dataInfo?.lstProfiles) ||
              !isEmpty(dataInfo?.lstTests)) && (
              <Grid item xs={12}>
                <Divider light variant="middle" />
              </Grid>
            )}

          {!isEmpty(dataInfo?.lstProfiles) ? (
            <Grid item xs={12}>
              <AddOnsItem listData={newListProfiles} />
            </Grid>
          ) : !isEmpty(dataInfo?.lstTests) ? (
            <Grid item xs={12}>
              <AddOnsItem listData={dataInfo?.lstTests} />
            </Grid>
          ) : null}
        </Grid>
      </Box>
    </Container>
  );
};

export default ProfileScreen;
